import {mapGetters} from "vuex";

export default {
  install (Vue, store) {
    Vue.mixin({
      computed: {
        ...mapGetters({
          authUser: 'getAuthUser',
          authUserTimezone: 'getAuthUserTimezone',
          authUserAdmin: 'authUserAdmin',
          authUserCourseLeader: 'authUserCourseLeader',
          authUserProfileType: 'getAuthUserProfileType',
          authUserProfileTypeLabel: 'getAuthUserProfileTypeLabel',
          authUserSessionLimits: 'getAuthUserSessionLimits',
          authUserStudyGroups: 'getAuthUserStudyGroups',

          profile_type: 'getAuthUserProfileType',
          profile_type_label: 'getAuthUserProfileTypeLabel',

        }),
        app_loading: {
          get: function () {
            return store.getters.getAppLoading
          },
          set: function (val) {
            store.commit('SET_APP_LOADING', val)
          }
        },
      }
    })

    Vue.prototype.$notify = function (content = '', color = '', options = {}) {
      store.dispatch('notifier/showMessage', {content, color, options})
    }
  }
}
